import * as ActionTypes from '../constants/actiontypes/services';
import ServiceData from '../constants/models/serviceData';
import { convertBackEndServiceTypesToFrontEndServiceType } from '../constants/utils/connectionTypes';
import * as R from 'ramda';
import * as Loadings from '../constants/loadings/service';
import * as Text from '../constants/toasterText/services';
import { toast } from 'react-toastify';

const toastConf = { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 };

const ServicesReducer = (state = {
    isLoading: [],
    serviceData: []
}, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_SERVICES_DATA_SUCCESS:
            let mappedServiceData = action.data.map(e => new ServiceData(e));
            mappedServiceData.forEach(s => {
                let frontendServiceType = convertBackEndServiceTypesToFrontEndServiceType(s.serviceType);

                if (R.isNil(state.serviceData[frontendServiceType])) {
                    state.serviceData[frontendServiceType] = [s];
                } else {
                    let itemIndex = state.serviceData[frontendServiceType].findIndex(sr => sr.id === s.id);
                    if (itemIndex !== -1) {
                        state.serviceData[frontendServiceType].splice(itemIndex, 1);
                    }
                    state.serviceData[frontendServiceType].push(s);
                }
            });
            return { ...state };
        case ActionTypes.ADD_SERVICES_DATA_REQUEST:
            if (!state.isLoading.includes(Loadings.ADD_NEW_SERVICE + action.serviceId)) {
                state.isLoading = state.isLoading.concat(Loadings.ADD_NEW_SERVICE + action.serviceId);
            }
            return { ...state };
        case ActionTypes.ADD_SERVICES_DATA_SUCCESS:
            let newItem = new ServiceData(action.data);
            let newItemFrontEndServiceType = convertBackEndServiceTypesToFrontEndServiceType(newItem.serviceType);
            if (R.isNil(state.serviceData[newItemFrontEndServiceType])) {
                state.serviceData[newItemFrontEndServiceType] = [];
            }
            state.serviceData[newItemFrontEndServiceType] = state.serviceData[newItemFrontEndServiceType].concat(newItem);
            state.isLoading = state.isLoading.filter(c => c !== Loadings.ADD_NEW_SERVICE + action.serviceId);
            toast.success(Text.addedSuccessfully, toastConf);
            return { ...state };
        case ActionTypes.ADD_SERVICES_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(c => c !== Loadings.ADD_NEW_SERVICE + action.serviceId);
            toast.error(Text.tryAddAgain, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_SERVICES_DATA_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_SERVICE_DATA + action.id)) {
                state.isLoading = state.isLoading.concat(Loadings.UPDATING_SERVICE_DATA + action.id);
            }
            return { ...state };
        case ActionTypes.UPDATE_SERVICES_DATA_SUCCESS:
            let updatedItem = new ServiceData(action.data);
            let itemToUpdateFrontEndServiceType = convertBackEndServiceTypesToFrontEndServiceType(updatedItem.serviceType);
            let itemToUpdateIndex = state.serviceData[itemToUpdateFrontEndServiceType].findIndex(sr => sr.id === updatedItem.id);
            state.serviceData[itemToUpdateFrontEndServiceType][itemToUpdateIndex] = updatedItem;
            state.isLoading = state.isLoading.filter(c => c !== Loadings.UPDATING_SERVICE_DATA + action.id);
            toast.success(Text.updatedSuccessfully, toastConf);
            return { ...state };
        case ActionTypes.UPDATE_SERVICES_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(c => c !== Loadings.UPDATING_SERVICE_DATA + action.id);
            toast.error(Text.tryUpdateAgain, toastConf);
            return { ...state };

        case ActionTypes.DELETE_SERVICES_DATA_SUCCESS:
            let serviceDataToDeleteIndex = state.serviceData[action.connectionType].findIndex(s => s.id === action.id);
            if (serviceDataToDeleteIndex > -1) {
                state.serviceData[action.connectionType].splice(serviceDataToDeleteIndex, 1);
            }
            toast.success(Text.deletedSuccessfully, toastConf);
            return { ...state };
        case ActionTypes.DELETE_SERVICES_DATA_FAILURE:
            toast.error(Text.tryDeleteAgain, toastConf);
            return { ...state };

        default:
            return { ...state };
    }
};
export default ServicesReducer;